var chunkMapping = {
	"64": [
		642,
		1081,
		1656,
		1681,
		1760,
		2147,
		2617,
		2862,
		4686,
		6703,
		7736,
		8681,
		9255
	],
	"263": [
		8739,
		7598,
		8147,
		559,
		2710
	],
	"268": [
		1335,
		1561,
		1863,
		5828,
		6966,
		6968,
		7122,
		8618,
		8726,
		9266,
		9300
	],
	"381": [
		7381
	],
	"438": [
		205,
		568,
		1126,
		1930,
		3406,
		3542,
		4381,
		6155,
		6404,
		6467,
		9267
	],
	"554": [
		385,
		1517,
		2470,
		5075,
		6561,
		6708,
		7970,
		8804,
		9050,
		9381,
		9583
	],
	"610": [
		137,
		848,
		4963,
		6586,
		8513,
		9283
	],
	"649": [
		828,
		2391,
		2777,
		3580,
		4064,
		5620,
		5894,
		6744,
		9518,
		9684
	],
	"773": [
		6344,
		5210,
		2733
	],
	"820": [
		111,
		1012,
		2591,
		2948,
		6317,
		7693,
		8520,
		8970,
		8999
	]
};
var idToExternalAndNameMapping = {
	"111": [
		"default",
		"./Badge",
		3071
	],
	"137": [
		"default",
		"./register",
		1757
	],
	"205": [
		"default",
		"./Drawer",
		3071
	],
	"385": [
		"default",
		"./PropertyList",
		4538
	],
	"559": [
		"default",
		"./Page",
		3071
	],
	"568": [
		"default",
		"./FiltersGroup",
		3071
	],
	"642": [
		"default",
		"./TimelineItem",
		3071
	],
	"828": [
		"default",
		"./UnboxingPageIntroduction",
		616
	],
	"848": [
		"default",
		"./Request",
		1441
	],
	"1012": [
		"default",
		"./Col",
		3071
	],
	"1081": [
		"default",
		"./ListHeader",
		3071
	],
	"1126": [
		"default",
		"./StatusFilter",
		3071
	],
	"1335": [
		"default",
		"./Text",
		3071
	],
	"1517": [
		"default",
		"./InputNumber",
		3071
	],
	"1561": [
		"default",
		"./PropertySelect",
		4538
	],
	"1656": [
		"default",
		"./OverviewHeader",
		3071
	],
	"1681": [
		"default",
		"./Divider",
		3071
	],
	"1760": [
		"default",
		"./Statistic",
		3071
	],
	"1863": [
		"default",
		"./icons/Clock",
		3071
	],
	"1930": [
		"default",
		"./FiltersBar",
		3071
	],
	"2147": [
		"default",
		"./Menu",
		3071
	],
	"2391": [
		"default",
		"./UnboxingPageHeader",
		616
	],
	"2470": [
		"default",
		"./EmptyStateConfig",
		3071
	],
	"2591": [
		"default",
		"./Tooltip",
		3071
	],
	"2617": [
		"default",
		"./TabPane",
		3071
	],
	"2710": [
		"default",
		"./Row",
		3071
	],
	"2733": [
		"default",
		"./icons/Warning",
		3071
	],
	"2777": [
		"default",
		"./Image",
		3071
	],
	"2862": [
		"default",
		"./Tabs",
		3071
	],
	"2948": [
		"default",
		"./Card",
		3071
	],
	"3406": [
		"default",
		"./icons/Delete",
		3071
	],
	"3542": [
		"default",
		"./Table",
		3071
	],
	"3580": [
		"default",
		"./UnboxingPageBody",
		616
	],
	"4064": [
		"default",
		"./UnboxingPageIntegrationBanner",
		616
	],
	"4381": [
		"default",
		"./EmptyStateFilters",
		3071
	],
	"4686": [
		"default",
		"./MenuItem",
		3071
	],
	"4963": [
		"default",
		"./History",
		1441
	],
	"5075": [
		"default",
		"./RowContainer",
		3071
	],
	"5210": [
		"default",
		"./Spin",
		3071
	],
	"5620": [
		"default",
		"./UnboxingPageRow",
		616
	],
	"5828": [
		"default",
		"./SegmentTypes",
		4538
	],
	"5894": [
		"default",
		"./UnboxingPageCol",
		616
	],
	"6155": [
		"default",
		"./StatusOption",
		3071
	],
	"6317": [
		"default",
		"./Modal",
		3071
	],
	"6344": [
		"default",
		"./CopyToClipboard",
		3071
	],
	"6404": [
		"default",
		"./EmptyStateData",
		3071
	],
	"6467": [
		"default",
		"./hooks",
		1441
	],
	"6561": [
		"default",
		"./FloatingContainer",
		3071
	],
	"6586": [
		"default",
		"./Tag",
		3071
	],
	"6703": [
		"default",
		"./Timeline",
		3071
	],
	"6708": [
		"default",
		"./Panel",
		3071
	],
	"6744": [
		"default",
		"./UnboxingPage",
		616
	],
	"6966": [
		"default",
		"./CatalogTypes",
		4538
	],
	"6968": [
		"default",
		"./Form",
		3071
	],
	"7122": [
		"default",
		"./Switch",
		3071
	],
	"7381": [
		"default",
		"./cWrapper",
		1441
	],
	"7598": [
		"default",
		"./List",
		3071
	],
	"7693": [
		"default",
		"./Selectors",
		1441
	],
	"7736": [
		"default",
		"./CardRow",
		3071
	],
	"7970": [
		"default",
		"./DynamicRows",
		3071
	],
	"8147": [
		"default",
		"./ListItem",
		3071
	],
	"8513": [
		"default",
		"./Icon",
		3071
	],
	"8520": [
		"default",
		"./Selectors",
		7672
	],
	"8618": [
		"default",
		"./Button",
		3071
	],
	"8681": [
		"default",
		"./DashboardEmbed",
		5296
	],
	"8726": [
		"default",
		"./Input",
		3071
	],
	"8739": [
		"default",
		"./Collapse",
		3071
	],
	"8804": [
		"default",
		"./InlineSegmentationBuilder",
		4538
	],
	"8970": [
		"default",
		"./isAuthorized",
		1441
	],
	"8999": [
		"default",
		"./Message",
		3071
	],
	"9050": [
		"default",
		"./RouteLeavingGuard",
		3071
	],
	"9255": [
		"default",
		"./Skeleton",
		3071
	],
	"9266": [
		"default",
		"./Select",
		3071
	],
	"9267": [
		"default",
		"./icons/Edit",
		3071
	],
	"9283": [
		"default",
		"./unboxing-page",
		616
	],
	"9300": [
		"default",
		"./Alert",
		3071
	],
	"9381": [
		"default",
		"./FormItem",
		3071
	],
	"9518": [
		"default",
		"./UnboxingPageDocumentation",
		616
	],
	"9583": [
		"default",
		"./InputGroup",
		3071
	],
	"9684": [
		"default",
		"./UnboxingPageCrossSelling",
		616
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}